import { ChangeDetectionStrategy, Component, inject, input, InputSignal } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MaintenancePageModel } from '@libs/shared/common';
import { FormatAbsolutePipe } from '@libs/shared/ui';

type MaintenanceVariant = 'default' | 'cms';

@Component({
  selector: 'ui-maintenance',
  imports: [
    FormatAbsolutePipe,
  ],
  templateUrl: './maintenance.component.html',
  styleUrl: './maintenance.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MaintenanceComponent {
  public readonly variant: InputSignal<MaintenanceVariant> = input<MaintenanceVariant>('default');
  public readonly maintenanceOverlayData: MaintenancePageModel | null = inject<MaintenancePageModel | null>(MAT_DIALOG_DATA, { optional: true });
}
